import { useTheme } from 'styled-components';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import gettext from '@sdk/lang/gettext';
import Text14 from '@sdk/components/ui/typography/Text14';
import Text16 from '@sdk/components/ui/typography/Text16';
import H4 from '@sdk/components/ui/typography/H4';
import Switcher from '@sdk/components/forms/Switcher';

import BlueArrow from '@web/assets/svg/UI/blue-arrow.svg';
import BlueDiscountText from '@web/assets/svg/UI/blue-discount.svg';
import GreyArrow from '@web/assets/svg/UI/grey-arrow.svg';
import GreyDiscountText from '@web/assets/svg/UI/grey-discount.svg';

import {
  TableCell,
  SwitchHeader,
  SwitchWrapper,
  DiscountWrapper,
  ArrowWrapper,
} from './billingPlans.styles';

type Props = {
  isPlanAnnual: boolean;
  togglePlan: (val: boolean) => void;
};

export const YearlyBilling = ({ isPlanAnnual, togglePlan }: Props) => {
  const theme = useTheme();

  return (
    <TableCell colSpan={3}>
      <SwitchHeader>
        <H4 semiBold themeColor={ThemeColorType.primary}>
          {gettext('Get more out of Sling for your business!')}
        </H4>
        <Text14 themeColor={ThemeColorType.gray}>
          {gettext('Upgrade your subscription to gain access to more features.')}
        </Text14>
      </SwitchHeader>

      <SwitchWrapper>
        <Text16 semiBold themeColor={isPlanAnnual ? ThemeColorType.iconGray : ThemeColorType.gray}>
          {gettext('Bill monthly')}
        </Text16>

        <Switcher
          value={isPlanAnnual}
          onChange={(value: boolean): void => togglePlan(value)}
          disabledBackgroundColor={theme.colors.primary}
          small
        />
        <Text16 semiBold themeColor={isPlanAnnual ? ThemeColorType.gray : ThemeColorType.iconGray}>
          {gettext('Bill annually')}
        </Text16>
      </SwitchWrapper>

      <DiscountWrapper>
        {isPlanAnnual ? <BlueDiscountText /> : <GreyDiscountText />}
        <ArrowWrapper>{isPlanAnnual ? <BlueArrow /> : <GreyArrow />}</ArrowWrapper>
      </DiscountWrapper>
    </TableCell>
  );
};
